import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'

const markAllNotificationsAsRead = async (): Promise<void> => {
  await api.post<void>('/notifications/read-all')
}

/** « Tout marquer comme lu » on the Notifications page. */
export const useMarkAllNotificationsAsRead = () => {
  const queryClient = useQueryClient()

  return useMutation<void, Error, void>({
    mutationFn: markAllNotificationsAsRead,
    onSuccess: () => {
      // Every tab and the menu badge, as for a single notification.
      queryClient.invalidateQueries({ queryKey: ['notifications'], refetchType: 'all' })
    },
  })
}
